var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "2c08169287930a6e4bdd26942b0f61af73cf4814"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["trees-online@better-place-forests-org"] = {
  id: "2c08169287930a6e4bdd26942b0f61af73cf4814"
};